module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown pos-abt",
    class: {
      open: _vm.open
    },
    staticStyle: {
      "top": "0px",
      "right": "2px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_vm._v(" Ações "), _c('span', {
    staticClass: "m-l-sm caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right no-padder"
  }, [(_vm.remocao.etapa < 2) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.acao('recolher')
      }
    }
  }, [_vm._v("\n        Iniciar Recolhimento\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.remocao.etapa < 3) ? _c('li', {
    attrs: {
      "disabled": _vm.remocao.etapa < 2
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.remocao.etapa === 2 && _vm.acao('transportar')
      }
    }
  }, [_vm._v("\n        Iniciar Transporte\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.remocao.etapa < 4) ? _c('li', {
    attrs: {
      "disabled": _vm.remocao.etapa < 3
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.remocao.etapa === 3 && _vm.acao('entregar')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square text-success"
  }), _vm._v("\n        Entregar\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d338712","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/context-menu/remocao-ticket.vue
// module id = 1494
// module chunks = 17